import PillarTableColumn from "shared/components/pillar-table/columns/PillarTableColumn";

export const findPillarTableColumnComponent = (
  componentType: any,
  searchObject: any = PillarTableColumn,
): any | null => {
  // 1) check for nested properties
  for (const key in searchObject) {
    if (
      Object.prototype.hasOwnProperty.call(searchObject, key) &&
      typeof searchObject[key] === "function"
    ) {
      for (const nestedKey in searchObject[key]) {
        if (
          Object.prototype.hasOwnProperty.call(searchObject[key], nestedKey) &&
          searchObject[key][nestedKey] === componentType
        ) {
          // return the matching component itself
          return searchObject[key][nestedKey];
        }
      }
    }
  }

  // 2) check direct children
  for (const key in searchObject) {
    if (
      Object.prototype.hasOwnProperty.call(searchObject, key) &&
      searchObject[key] === componentType
    ) {
      return searchObject[key];
    }
  }

  // 3) recurse into each child
  for (const key in searchObject) {
    if (
      Object.prototype.hasOwnProperty.call(searchObject, key) &&
      typeof searchObject[key] === "function"
    ) {
      const found = findPillarTableColumnComponent(
        componentType,
        searchObject[key],
      );
      if (found) {
        return found;
      }
    }
  }

  // not found
  return null;
};
